<div class="bg-dark-grey min-vh-100 d-flex flex-row align-items-center position-relative">
  <lib-auth-language-switcher></lib-auth-language-switcher>
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="6" xl="4">
        <c-card-group>
          <!-- Success State -->
          @if (success()) {
            <c-card class="p-4 shadow-sm border-0">
              <c-card-body class="text-center">
                <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

                <h3 class="mb-3 text-success">{{ 'forgot_password.check_email_title' | translate }}</h3>

                <c-alert color="success" class="mb-4">
                  <p class="mb-0">
                    {{ 'forgot_password.check_email_message' | translate }}
                  </p>
                </c-alert>

                <p class="text-body-secondary mb-4">
                  {{ 'forgot_password.check_spam' | translate }}
                </p>

                <button
                  cButton
                  color="primary"
                  class="w-100"
                  (click)="backToLogin()"
                >
                  {{ 'forgot_password.back_to_login' | translate }}
                </button>
              </c-card-body>
            </c-card>
          } @else {
            <!-- Form State -->
            <c-card class="p-4 shadow-sm border-0">
              <c-card-body>
                <form cForm (ngSubmit)="requestReset()">
                  <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

                  <h3 class="mb-2">{{ 'forgot_password.title' | translate }}</h3>
                  <p class="text-body-secondary mb-4">
                    {{ 'forgot_password.description' | translate }}
                  </p>

                  <c-input-group class="mb-4">
                    <span cInputGroupText>
                      <svg cIcon name="cilEnvelopeClosed"></svg>
                    </span>
                    <input
                      cFormControl
                      type="email"
                      [(ngModel)]="email"
                      name="email"
                      placeholder="{{ 'forgot_password.email_placeholder' | translate }}"
                      unassistedInput
                      [disabled]="isLoading()"
                      required
                    />
                  </c-input-group>

                  @if (error(); as err) {
                    <c-alert color="danger" class="mb-3">
                      {{ err }}
                    </c-alert>
                  }

                  <c-row>
                    <c-col xs="12">
                      <button
                        cButton
                        color="primary"
                        type="submit"
                        class="w-100"
                        [disabled]="isLoading() || !email().trim()"
                      >
                        @if (isLoading()) {
                          <c-spinner size="sm" class="me-2"></c-spinner>
                          {{ 'forgot_password.sending' | translate }}
                        } @else {
                          {{ 'forgot_password.send_reset_link' | translate }}
                        }
                      </button>
                    </c-col>
                  </c-row>

                  <div class="text-center mt-3">
                    <button
                      cButton
                      color="link"
                      type="button"
                      class="px-0"
                      routerLink="/login"
                      [disabled]="isLoading()"
                    >
                      {{ 'forgot_password.back_to_login' | translate }}
                    </button>
                  </div>
                </form>
              </c-card-body>
            </c-card>
          }
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>